import React from "react";
import Icons from "../../../../util/Icons";
import Context from "../../../../../context/Context";
import CheckCircleIcon from "calcite-ui-icons-react/CheckCircleIcon"

const CSS = {
    popoutInner: "i-popout-inner i-booking-confirmed-popup",
    popoutOuter: "i-popout-outer",
    panelHeader: "i-infopanel-header i-panel-header",
    panelHeaderTools: "i-panel-header-tools",
    filterForm: "i-filter-form",
    toggleAllDay: "i-toggle-all-day",
    toggleLabel: "i-toggle-label",
    durationFilter: "i-duration-filter",
    durationFilterForm: "i-duration-filter-form",
    durationGroup: "i-duration-group",
    durationDate: "i-date",
    durationTime: "i-time",
    iconContainer: "i-sidebar-icon-container i-filter-container",
    icon: "i-more-menu-icon",
    spaceFilters: "i-space-filter",
    button: "i-book-button",
    dateString: "i-date-string",
    bookingConfirmedBody: "i-booking-confirmed-body"
  };

export default class BookingConfirmed extends React.Component {

    render(){
        const i18n = Context.instance.i18n;
        let title = i18n.more.bookWorkspace.bookingDetailsTitle;
        title = title.replace("{levelName}", this.props.levelName);
        title = title.replace("{buildingName}", this.props.facilityName);

        return(
        <div className={CSS.popoutOuter}>
            <div className={CSS.popoutInner}>
                <div className={CSS.panelHeader}>
                <div className={CSS.bookingDetailsTitle}>
                    <h2>{this.props.unitName}</h2>
                    <h4>{title}</h4>
                </div>
                <div className={CSS.panelHeaderTools}>
                    <button ref={this.closeRef}
                    title={i18n.general.close} aria-label={i18n.infoPanel.closeAriaLabel}
                    tabIndex="0" onClick={this.props.closePopup}>
                    {Icons.close()}
                    </button>
                </div>
                </div>
                <div className={CSS.bookingConfirmedBody}>
                        <CheckCircleIcon color="green"/>
                        <h1>{i18n.more.bookWorkspace.bookingRequested}</h1>
                        <h2>{i18n.more.bookWorkspace.bookingRequestedInfo}</h2>
                </div>
        </div>
        </div>
        );
    }
} 